import type { MailboxInfo } from 'owa-client-types';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

export function isPoliciesEnabledForAccount(mailboxInfo: MailboxInfo): boolean {
    return (
        !isConsumer(undefined, mailboxInfo) &&
        isAccountFeatureEnabled('ocps-policy-check', mailboxInfo) &&
        isAccountFeatureEnabled('policy-ocps-owsprime', mailboxInfo)
    );
}
